// @ts-nocheck

export const localeCodes =  [
  "en",
  "fr"
]
export const localeLoaders = {
  en: [],
  fr: []
}
export const vueI18nConfigs = [
  () => import("#nuxt-i18n/58143f20" /* webpackChunkName: "config_i18n_46config_46ts_58143f20" */)
]
export const normalizedLocales = [
  {
    code: "en",
    iso: "en-US",
    language: undefined
  },
  {
    code: "fr",
    iso: "fr-FR",
    language: undefined
  }
]

